import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Table,
  IconButton,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Typography,
  Divider,

} from "@mui/material";
import CustomModal from "../../common/CustomModal";
import CreateCompanyModules from "./CreateCompanyModules";
import MessageBox from "../../common/CustomMessageBox";
import CustomDelete from "../../common/CustomDeleteAlert";
import { GET_PROFILE, GET_PERMISSIONS, DELETE_PROFILE } from "../../../services/apiRoutes";
import { genericGet } from "../../../services/apiServices";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CustomMaster from "../../common/CustomMaster";
import { AccessDenied, formatDate, getBusinessProfile, getSkipListBusiness, getSkipListOwner, hasCreatePermission, hasDeletePermission, hasEditPermission, hasViewPermission, } from "../../../services/CommonServices";
import UpdateProfiles from "../UpdateMaster/UpdateProfiles";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import UpdatePermission from "../UpdateMaster/UpdatePermission";
import CustomButton from "../../common/CustomButton";
import { useLocation } from "react-router-dom";
import axios from "axios";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { t } from "../../../constants/translationHelper";




const Profiles = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const skipListOwner = getSkipListOwner;
  const skipListBusiness = getSkipListBusiness;


  const [open, setOpen] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [updateProfileModal, setUpdateProfileModal] = useState(false);
  const [permission, setPermissions] = useState()
  const [selectedId, setSelectedId] = useState(null);
  const [deleteAlert, setDeleteAlert] = useState(false)
  const [loading, setLoading] = useState(false)
  const [viewData, setViewData] = useState([])
  const [profile, setProfile] = useState([]);
  const [businessProfile, setBusinessProfile] = useState(null);
  const [message, setMessage] = useState({
    open: false,
    text: "",
    type: "",
  });
  const [rowId, setRowId] = useState('')

  const handleOpenDeleteAlert = (rowId) => {
    setDeleteAlert(true)
    setRowId(rowId)
  }
  const skipList =
    businessProfile === "owner" || businessProfile === "partner"
      ? skipListOwner
      : skipListBusiness;

  const filteredViewData = viewData?.filter(
    item => !skipList.includes(item.companyModuleId)
  ) || [];

  const getCommonData = async () => {
    const profileData = getBusinessProfile();
    setBusinessProfile(profileData);
  };



  useEffect(() => {
    let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
    // let mappedPath = currentPath.replace("/alexxcansols", "/app");
    const mappedPath = currentPath.replace(
            /^\/(alexxcansols|app|partner)/,
            "/app"
        );

    let editPermision = hasEditPermission(mappedPath, rolePermisionsData?.permissions)
    let deletePermission = hasDeletePermission(mappedPath, rolePermisionsData?.permissions)
    let createPermision = hasCreatePermission(mappedPath, rolePermisionsData?.permissions)
    let viewPermision = hasViewPermission(mappedPath, rolePermisionsData?.permissions)
    setPermissions({
      edit: editPermision,
      delete: deletePermission,
      create: createPermision,
      view: viewPermision,
    })
  }, [])



  const handleUpdateClick = (id) => {
    setSelectedId(id);
    getPermissionsByProfileId(id)
    setUpdateModal(true);
  };
  const handleUpdateProfileClick = (id) => {
    setSelectedId(id);
    getPermissionsByProfileId(id);
    setUpdateProfileModal(true);
  };


  const handleCloseUpdate = () => {
    setUpdateModal(false);
    setUpdateProfileModal(false);
  };


  const handleClose = () => {
    try {
      setOpen(false);
    } catch (error) {
      console.error("Error in handleClose:", error);
    }
  };

  const getProfiles = async () => {
    try {
      const response = await genericGet({ url: GET_PROFILE });
      if (response.status == 200) {
        setProfile(response.data.companyProfiles);
      }
    } catch (error) {
    } finally {
    }
  };

  const handleViewOpen = (id) => {
    getPermissionsByProfileId(id)
    setViewModal(true)
  }
  const getPermissionsByProfileId = async (id) => {
    try {
      const response = await genericGet({ url: `${GET_PERMISSIONS}/${id}` });
      if (response.status == 200) {
        setViewData(response.data.profile);
      }
    } catch (error) {
    } finally {
    }
  };

  useEffect(() => {
    getProfiles();
    getCommonData();
  }, []);


  const handleDelete = async (profileId) => {
    setLoading(true);
    const authToken = sessionStorage.getItem('accessToken');

    try {
      const response = await axios.delete(DELETE_PROFILE(profileId), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        setMessage({
          open: true,
          text: "deleted successfully",
          type: "success",
        });
        getProfiles();
        setDeleteAlert(false);

      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);

      if (error.response) {
        if (error.response.status === 409) {
          setMessage({
            open: true,
            text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
            type: "error",
          });
        } else {
          setMessage({
            open: true,
            text: "An error occurred while deleting the Data.",
            type: "error",
          });
        }
      } else {
        console.error("Error deleting Data", error);
        setMessage({
          open: true,
          text: "Network error. Please try again later.",
          type: "error",
        });
      }
    }
  };

  console.log(viewData)
  const defaultView = 'profiles';

  const mainContent = (
    <>
      <Grid
        container
        spacing={1}
        sx={{
          position: "sticky",
          alignItems: "center"
        }}
      >
        <Grid item xs={6} md={6}>
          <Typography
            sx={{ fontWeight: 600, color: "#212529", fontSize: "18px" }}
          >
            {t("Profiles")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          md={6}
          sx={{
            display: "flex",
            justifyContent: "flex-end"
          }}
        >
          {permission?.create &&
            <CustomButton
              title="Add Profile"
              size="small"
              variant="contained"
              onClick={() => setOpen(true)} />
          }

        </Grid>
      </Grid>
      <Divider />

      <Box sx={{ pt: 2 }}>
        <Box sx={{ overflowX: "auto", overflowY: "auto" }}>
          <Table sx={{ width: "100%" }}>
            <TableHead>
              <TableRow sx={{ height: "40px", backgroundColor: "#e7f0f7" }}>
                <TableCell rowSpan={2}>{t("Profile Name")}</TableCell>
                <TableCell rowSpan={2}>{t("Profile Description")}</TableCell>
                <TableCell rowSpan={2}>{t("Created By")}</TableCell>
                <TableCell rowSpan={2}>{t("Permission")}</TableCell>
                <TableCell rowSpan={2}>{t("Action")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {profile &&
                profile.map((v) => (
                  <TableRow sx={{ borderBottom: "1px solid #e0e0e0" }}>
                    <TableCell>{v?.profileName}</TableCell>
                    <TableCell>{v?.profileDescription}</TableCell>
                    <TableCell>{formatDate(v?.createdAt)}</TableCell>
                    <TableCell >
                      {permission?.edit && v?.profileName !== "Standard" && v?.profileName !== "Member" && (
                        <IconButton onClick={() => handleUpdateClick(v.profileId)}>
                          <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                        </IconButton>
                      )}
                    </TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleViewOpen(v.profileId)}>
                        <VisibilityIcon style={{ color: "#059212" }} />
                      </IconButton>

                      {permission?.edit && v?.profileName !== "Standard" && v?.profileName !== "Member" && (
                        <IconButton onClick={() => handleUpdateProfileClick(v.profileId)}>
                          <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                        </IconButton>
                      )}
                      {permission?.delete && v?.profileName !== "Standard" && v?.profileName !== "Member" && (
                        <IconButton
                          onClick={() => handleOpenDeleteAlert(v.profileId)}
                        >
                          <DeleteOutlineOutlinedIcon style={{ color: "#E4003A" }} />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Box>
      </Box>

      <CustomModal
        open={open}
        handleClose={handleClose}
      >
        <CreateCompanyModules
          handleClose={handleClose}
          setMessage={setMessage}
          getProfiles={getProfiles}
        />
      </CustomModal>
      <MessageBox
        open={message.open}
        onClose={() => setMessage({ ...message, open: false })}
        message={message.text}
        type={message.type}
      />

      <CustomModal
        open={viewModal}
        handleClose={() => setViewModal(false)}
      >

        <Grid container spacing={1} my={1}>
          <Grid item xs={12} sm={6} >
            {viewData && viewData[0]?.profile?.profileName}
          </Grid>
        </Grid>
        <Divider sx={{ my: 2 }} />

        <Box sx={{ pt: 2 }}>
          <Box sx={{ overflowX: 'auto', overflowY: 'auto' }}>
            <Table sx={{ width: '100%' }}>
              <TableHead>
                <TableRow sx={{ height: '40px', backgroundColor: '#e7f0f7' }}>
                  <TableCell sx={{ ...styles.tableCell, width: '200px' }} rowSpan={2}>{t("Module Name")}</TableCell>
                  <TableCell sx={{ ...styles.tableCell, width: '100px' }} rowSpan={2}>{t("Create")}</TableCell>
                  <TableCell sx={{ ...styles.tableCell, width: '100px' }} rowSpan={2}>{t("Update")}</TableCell>
                  <TableCell sx={{ ...styles.tableCell, width: '100px' }} rowSpan={2}>{t("View")}</TableCell>
                  <TableCell sx={{ ...styles.tableCell, width: '100px' }} rowSpan={2}>{t("Delete")}</TableCell>
                  <TableCell sx={{ ...styles.tableCell, width: '100px' }} rowSpan={2}>{t("Export")}</TableCell>

                </TableRow>
              </TableHead>
              <TableBody>
                {filteredViewData.map((module, index) => (
                  <TableRow key={index} sx={{ borderBottom: '1px solid #e0e0e0' }}>
                    <TableCell sx={styles.tableCell}>{module.companyModule?.moduleName}</TableCell>
                    <TableCell sx={styles.tableCell}>
                      <Switch
                        name="create"
                        checked={module.creates == 1 ? true : false}
                        disabled
                      />
                    </TableCell>
                    <TableCell sx={styles.tableCell}>
                      <Switch
                        name="update"
                        checked={module.updates == 1 ? true : false}
                        disabled
                      />
                    </TableCell>
                    <TableCell sx={styles.tableCell}>
                      <Switch
                        name="view"
                        checked={module.views == 1 ? true : false}
                        disabled
                      />
                    </TableCell>
                    <TableCell sx={styles.tableCell}>
                      <Switch
                        name="delete"
                        checked={module.deletes == 1 ? true : false}
                        disabled
                      />
                    </TableCell>
                    <TableCell sx={styles.tableCell}>
                      <Switch
                        name="export"
                        checked={module.export == 1 ? true : false}
                        disabled
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </Box>
      </CustomModal>

      <CustomModal
        open={updateProfileModal} handleClose={handleCloseUpdate}>
        <UpdateProfiles
          handleClose={handleCloseUpdate}
          profileId={selectedId}
          fetchData={getProfiles}
          setMessage={setMessage}
          viewData={viewData}
        />
      </CustomModal>
      <CustomModal
        open={updateModal} handleClose={handleCloseUpdate}>
        <UpdatePermission
          handleClose={handleCloseUpdate}
          profileId={selectedId}
          fetchData={getProfiles}
          setMessage={setMessage}
        />
      </CustomModal>
      <CustomDelete
        handleDelete={handleDelete}
        open={deleteAlert}
        rowId={rowId}
        handleClose={() => setDeleteAlert(false)}
      />
    </>

  );
  const getMainContent = (mainContent, permission) => {
    return permission?.view ? mainContent : null;
  };
  return (
    <>
      <CustomMaster
        defaultView={defaultView}
        mainContent={getMainContent(mainContent, permission)}
      />
      {!permission?.view && <AccessDenied />}
    </>
  );
};

export default Profiles;
const styles = {
  tableCell: {
    border: '1px solid #dee2e6',
    color: '#212529',
    fontWeight: 600,
    fontSize: '14px',
    textAlign: 'center',
    p: '4px',
  },
};